import React from 'react';
import { useSelector } from 'react-redux';
import { BaseChart, Retry } from '@components/common';
import { getFirstAppliedFilter } from '@store/common/selectors';
import { globalOrderBySelector } from '@store/trends/base/selectors';
import { FlexFill } from '@components/common/Utils/Layout';
import { getMetricDisplayName } from '@src/utils/metrics';
import { SecondaryMetricHeader, SecondaryMetricWrapper } from './styled';
import useSecondaryToolbox from '../hooks/secondary/useSecondaryToolbox';
import { useFetchMetricSeries } from '../hooks/useMetricSeries';
import useSecondaryQuery from '../hooks/secondary/useSecondaryQuery';
import { useFetchDod } from '../hooks/useDodSeries';
import { useFetchMetricFilterSeries } from '../hooks/useMetricFilterSeries';
import { DATA_TAGS } from '../hooks/useData';
import { useFetchCompare } from '../hooks/useCompareSeries';
import { useSecondaryCompareTimeseriesQueries } from '../hooks/useCompareTimeseriesQueries';
import LogAxis from '../control-panel/LogAxis';

function SecondaryMetric({ activeTool }) {
  const metric = useSelector(globalOrderBySelector);
  const appliedFilter = useSelector(getFirstAppliedFilter);

  const { isFetching, isError, refetch } = useFetchMetricSeries({
    metric,
    enabled: true,
    useBuildQuery: useSecondaryQuery,
    dataTag: DATA_TAGS.secondary,
  });
  // TODO: indicator for secondary queries?
  const { isFetching: isMetricFilterFetching } = useFetchMetricFilterSeries({
    enabled: true,
    useBuildQuery: useSecondaryQuery,
    dataTag: DATA_TAGS.secondaryMetricFilter,
  });
  const { isFetching: isDoDFetching } = useFetchDod({
    enabled: true,
    useBuildQuery: useSecondaryQuery,
    dataTag: DATA_TAGS.secondaryDod,
  });
  const { isFetching: isCompareSeriesFetching } = useFetchCompare({
    enabled: true,
    useBuildQuery: useSecondaryCompareTimeseriesQueries,
    dataTag: DATA_TAGS.secondaryCompare,
  });

  const { chartInstanceRefCb } = useSecondaryToolbox({
    metric,
    activeTool,
    appliedFilter,
    naMode: false,
    diagMode: false,
  });

  return (
    <SecondaryMetricWrapper>
      <SecondaryMetricHeader>
        <span>{getMetricDisplayName({ metricKey: metric })}</span>
        <FlexFill />
        <LogAxis />
      </SecondaryMetricHeader>
      <div style={{ minHeight: 100 }}>
        <Retry isLoading={isFetching} showError={isError} fetchData={refetch} progress={true}>
          <BaseChart
            key="secondary-metric"
            chartId={metric}
            chartInstanceRefCb={chartInstanceRefCb}
            style={{ height: '100%' }}
          />
        </Retry>
      </div>
    </SecondaryMetricWrapper>
  );
}

export default SecondaryMetric;
